import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  getEnglishFooterList,
  getFooterList,
  getPartnersFooterList,
  getRetiredFooterList,
  getVSATFooterList,
} from "../../services/footer/footer.service";
import styles from "./Footer.module.css";

const Footer = () => {
  const location = useLocation();
  let [footer, setFooter] = useState([]);
  let [isEnglish, setIsEnglish] = useState(false);
  useEffect(() => {
    if (window.location.href.indexOf("/en") >= 0) {
      setIsEnglish(true);
      getEnglishFooterList().then((data) => {
        setFooter((data && data.data && data.data.data) || []);
      });
    } else {
      setIsEnglish(false);
      if (window.location.href.indexOf("/vsat") >= 0) {
        getVSATFooterList().then((data) => {
          setFooter((data && data.data && data.data.data) || []);
        });
      } else if (window.location.href.indexOf("/partners") >= 0) {
        getPartnersFooterList().then((data) => {
          setFooter((data && data.data && data.data.data) || []);
        });
      } else if (window.location.href.indexOf("/retired") >= 0) {
        getRetiredFooterList().then((data) => {
          setFooter((data && data.data && data.data.data) || []);
        });
      } else {
        getFooterList().then((data) => {
          setFooter((data && data.data && data.data.data) || []);
        });
      }
    }
  }, [location, isEnglish]);
  useEffect(() => {
    if (window.location.href.indexOf("/en") >= 0) {
      setIsEnglish(true);
    } else {
      setIsEnglish(false);
    }
  }, [location]);
  return (
    <footer className={styles.footer}>
      <div className={styles.footerPattern} />
      <div className={"container"}>
        <div className={styles.dFlex}>
          {footer.map((item, key) => (
            <div
              key={key + "-footer-index"}
              className={`${styles.flexOne} ${styles.footerHeading}`}
            >
              {(item.destination_url || "").startsWith("http") ? (
                <a
                  className={styles.headingLink}
                  href={item.destination_url}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {item.title}
                </a>
              ) : (item.destination_url || "").length > 2 ? (
                <Link
                  className={styles.headingLink}
                  to={{
                    pathname: item.destination_url.split("?")[0],
                    search:
                      item.destination_url.split("?")[1] &&
                      item.destination_url.split("?")[1].length > 0
                        ? "?" + item.destination_url.split("?")[1]
                        : null,
                  }}
                >
                  {item.title}
                </Link>
              ) : (
                <div className={styles.headingLink}>{item.title}</div>
              )}
              {Array.isArray(item.children) && item.children.length > 0 ? (
                <ul className={styles.subChilds}>
                  {item.children.map((child, key) => (
                    <li key={key + 2000 + "-subchild-item"}>
                      <i className={"fa fa-angle-left"}></i>{" "}
                      {(child.destination_url || "").startsWith("http") ? (
                        <a
                          className={`${styles.headingLink}`}
                          href={child.destination_url}
                          rel="noreferrer"
                          target="_blank"
                        >
                          {child.title}
                        </a>
                      ) : (child.destination_url || "").length > 2 ? (
                        <Link
                          className={`${styles.headingLink}`}
                          to={{
                            pathname: child.destination_url.split("?")[0],
                            search:
                              child.destination_url.split("?")[1] &&
                              child.destination_url.split("?")[1].length > 0
                                ? "?" + child.destination_url.split("?")[1]
                                : "",
                          }}
                        >
                          {child.title}
                        </Link>
                      ) : (
                        <div className={styles.headingLink}>{child.title}</div>
                      )}
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
          <div className={`${styles.flexOne} ${styles.footerHeading}`}>
            <div className={`hidden-xs ${styles.logoFooter}`}>
              <img
                src={"/assets/image/logo-header-reverse.png"}
                alt="لوگوی شرکت"
              />
            </div>
            <ul className={`${styles.subChilds} ${styles.contactUsSeparator}`}>
              <li className={styles.contactUsForm}>
                <i className="fa fa-phone"></i>
                <span> تلفن تماس : 27370</span>
              </li>
              <li className={styles.contactUsForm}>
                <i className="fa fa-fax"></i>
                <span> فاکس: 22221022 و 79-27377274</span>
              </li>
              <li className={styles.contactUsForm}>
                <i className="fa fa-address-card"></i>
                <span> کد پستی : 1545654311</span>
              </li>
              <li className={styles.contactUsForm}>
                <i className="fa fa-envelope"></i>
                <span> پست الکترونیک: Info@isc.co.ir</span>
              </li>
              <li className={styles.contactUsForm}>
                <i className="fa fa-map-pin"></i>
                <span>
                  {" "}
                  آدرس : تهران، خیابان میرداماد، میدان مادر(محسنی)، خیابان شاه
                  نظری، خیابان مددکاران، تقاطع خواجوی، شماره 6، ساختمان مرجان.
                </span>
              </li>
            </ul>
          </div>
          <div className={"clearfix"}></div>
        </div>
      </div>
      <div className={`${styles.footerBottom}`}>
        تمامی حقوق مادی و معنوی این سایت متعلق به شرکت خدمات انفورماتیک می باشد.
      </div>
    </footer>
  );
};

export default Footer;
